function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Accordion from '@engine/components/presentational/base/accordion.js';
import ApplePayMerchantRegistrationForm from '@engine/components/containers/apple-pay-merchant-registration/form';
import React from 'react';

var ApplePayMerchantOnboardingPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(ApplePayMerchantOnboardingPanel, _React$Component);

  var _super = _createSuper(ApplePayMerchantOnboardingPanel);

  function ApplePayMerchantOnboardingPanel() {
    _classCallCheck(this, ApplePayMerchantOnboardingPanel);

    return _super.apply(this, arguments);
  }

  _createClass(ApplePayMerchantOnboardingPanel, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement(Accordion, {
        icon: "user",
        title: I18n.t('javascript.merchants.apple_pay_onboarding.direct_registration')
      }, React.createElement("div", {
        className: "mb-5 input-info-text"
      }, React.createElement("i", {
        className: "glyphicon glyphicon-info-sign mr-5"
      }), I18n.t('javascript.merchants.apple_pay_onboarding.validate_your_urls')), React.createElement("div", {
        className: "mb-5"
      }, React.createElement("i", {
        className: "glyphicon glyphicon-download"
      }), React.createElement("a", {
        href: this.props.validation_file_url
      }, " Download validation file")), React.createElement("div", {
        className: "alert alert-info-light"
      }, I18n.t('javascript.merchants.apple_pay_onboarding.host_your_files_to'), React.createElement("pre", null, React.createElement("code", null, I18n.t('javascript.merchants.apple_pay_onboarding.host_under'))), I18n.t('javascript.merchants.apple_pay_onboarding.for_each_domain')), React.createElement(ApplePayMerchantRegistrationForm, {
        url: this.props.url,
        contractDomains: this.props.contract_domains
      })));
    }
  }]);

  return ApplePayMerchantOnboardingPanel;
}(React.Component);

export default ApplePayMerchantOnboardingPanel;